exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#signature[data-v-1a2b230c]{border:2px solid #dc3545;border-radius:5px;background-image:linear-gradient(#fff,#fff);background-origin:border-box;background-clip:content-box,border-box}", ""]);

// exports
